/**
 * web/src/screens/Settings/concierge.tsx — the Concierge section of Settings
 * (card MudceTexpbq1): moved verbatim out of index.tsx.
 */
import { AgentSettings } from '../AI/AgentSettings';
import type { Toggles } from './types';

export function ConciergeSection({
  onOpenAI, toggles, failed,
}: {
  onOpenAI?: () => void;
  toggles: Toggles | null;
  failed: boolean;
}) {
  const anyPermission = toggles ? Object.values(toggles).some(Boolean) : false;

  return (
    <>
        {/* ── Concierge: the agent's switches ────────────────────────── */}
        <section className="set-section" aria-labelledby="set-agent-title">
          <h3 className="set-section-title" id="set-agent-title">
            Concierge
          </h3>
          <p className="set-section-note">
            Permissions live here — turn one on, then open the concierge screen.
          </p>

          <div className="set-row set-agent-toggle">
            <div className="set-text">
              <div className="set-label">Open the concierge</div>
              <div className="set-note">View chat history, inbox permissions and access log.</div>
            </div>
            {onOpenAI && (
              <button
                type="button"
                className="pear-btn pear-btn-mustard set-agent-btn"
                id="btn-open-ai"
                onClick={() => onOpenAI()}
              >
                Open
              </button>
            )}
          </div>

          {toggles === null && !failed && (
            <p className="set-loading" aria-busy="true">
              Loading…
            </p>
          )}
          {failed && (
            <p className="set-error">
              Couldn’t load your permissions. Try again.
            </p>
          )}
          {toggles !== null && !anyPermission && (
            <p className="set-empty">Every permission is off — nothing to configure yet.</p>
          )}

          <AgentSettings visible={anyPermission} />
        </section>
    </>
  );
}
